import { render, staticRenderFns } from "./TransferHero.vue?vue&type=template&id=330d3f1f&scoped=true&lang=pug&"
import script from "./TransferHero.vue?vue&type=script&lang=js&"
export * from "./TransferHero.vue?vue&type=script&lang=js&"
import style0 from "./TransferHero.vue?vue&type=style&index=0&id=330d3f1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d3f1f",
  null
  
)

export default component.exports